import type { FaireThemeEntity } from "../../entity_types/theme";

export const low_tox_ancestral_wellness: FaireThemeEntity = {
  token: "low-tox-ancestral-wellness",
  type: "theme",
  name: "Low-Tox Ancestral Wellness",
  description: "Clean, herb-infused remedies and tallow-based skincare that prioritize non-toxic ingredients and traditional healing methods.",
  teaser: "Non-toxic, small-batch remedies your wellness customers already trust.",
  detail: "This aligns with your top distinctive interests in essential oils and healing salves. Featuring Frankincense Tallow balm, Wild Yam hormone support rollers, and organic oil of oregano -- all matching your preference for handmade, small-batch quality.",
  bgColor: "#F5D6D6",
  tileBgColor: "#6b7a3d",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_4zm9prvucn",
    "p_6jmfmc473r",
    "p_v9vh5q5drf",
    "p_jdby3x8ez7",
    "p_sqvrgrf8vg",
    "p_wkbxajunjm",
    "p_fj2bbsuqf8",
    "p_9ktrgm5h9u",
    "p_8k6f8g7s88",
    "p_mmcbhxghnx",
    "p_asf6zq38pw",
    "p_s46e7wm4wv",
    "p_nsz76f854y",
    "p_nc5ryb94n2",
    "p_f7wx7hpyct",
    "p_225q3pgfxf",
    "p_x6kh4xrxe7",
    "p_e8p9vv37k7",
    "p_ekkpeqxzm5",
    "p_bqsbnl15ng",
    "p_4kyn7eah28",
    "p_e26jdu74zp",
    "p_uw4ct7ykxk",
    "p_429u8k4uq3",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
